<template>
  <v-container>
    <v-card class="bg-card rounded-xl py-5 mt-5">
      <h4 class="text-center text-h4 mb-5">Historial de Sincronización</h4>

      <div
        class="mx-5 mx-md-8 px-md-8 d-flex flex-column flex-md-row align-center align-md-baseline"
      >
        <div style="width: 250px">
          <v-text-field
            outlined
            dense
            solo
            placeholder="Buscar"
            class="rounded-lg"
            prepend-inner-icon="fa-search"
            v-model="search"
          ></v-text-field>
        </div>

        <v-spacer />
      </div>

      <div class="mx-5 mx-md-8 px-md-8">
        <v-data-table
          :headers="headers"
          :items="rows.items"
          :items-per-page="-1"
          hide-default-footer
          disable-sort
          class="elevation-1 rounded-lg"
        >
          <template v-slot:item.date="{ item }">
            {{ formatDate(item.date) }} {{ formatHours(item.date) }}
          </template>
        </v-data-table>
        <div
          class="pt-2 d-flex flex-column flex-md-row align-center justify-end"
        >
          <span class="font-quicksand">Filas por páginas: </span>
          <span style="width: 50px" class="mx-md-2">
            <v-select
              v-model="itemsPerPage"
              :items="itemsPerPages"
              class="font-quicksand"
              @change="onItemsPerPageChange"
            ></v-select>
          </span>
          <span class="font-quicksand"
            >{{ rowsRangeStart }}-{{ rowsRangeEnd }} de {{ rows.totalItems }}
          </span>
          <v-pagination
            v-model="page"
            :length="rows.totalPages"
            :total-visible="pageVisible"
            color="red"
            class="font-work-sans"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { format } from 'date-fns'
import Repository from '@/repositories/RepositoryFactory'
import { createPaginationMixin } from '@/mixins/pagination'

const SyncHistoryRepository = Repository.get('syncHistories')

export default {
  name: 'SyncHistories',
  mixins: [createPaginationMixin({ debounceMs: 500 })],
  data: () => ({
    search: '',
    headers: [
      {
        text: 'URL',
        align: 'center',
        class:
          'primary white--text rounded-tl-lg font-weight-bold text-subtitle-2',
        value: 'URL',
      },
      {
        text: 'Acción',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'action',
      },
      {
        text: 'Resultado',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'result',
      },
      {
        text: 'Fecha',
        align: 'center',
        class:
          'primary white--text rounded-tr-lg font-weight-bold text-subtitle-2',
        value: 'date',
      },
    ],
    itemsPerPages: [10, 20, 30, 50, 100],
  }),
  computed: {
    roleUser: function () {
      return this.$store.state.auth.user?.roleId || ''
    },
  },
  methods: {
    fetchPage: function (params) {
      return SyncHistoryRepository.get(params)
    },
    formatDate: (value) => {
      const date = value ? new Date(value) : new Date()
      return format(date, 'dd/MM/yyyy')
    },
    formatHours: (value) => {
      const date = value ? new Date(value) : new Date()
      return date.toLocaleString('es-VE', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      })
    },
  },
}
</script>
